module.exports = __webpack_public_path__ + "fonts/iconfont.79545e3b.woff";